import * as React from "react";
export default function TrustpilotStars (props) {
  return (
    <>
    <svg xmlns="http://www.w3.org/2000/svg" className="rating-svg" viewBox="0 0 140 24" role="img" aria-label="4.5 stars">
  <defs>
    <linearGradient id="starFillHalf" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="50%" stopColor="#ffffff"/>
      <stop offset="50%" stopColor="transparent"/>
    </linearGradient>
  </defs>

  <g transform="translate(0, 0)">
    <rect width="24" height="24" fill="#00804d" rx="3" />
    <path fill="#ffffff" d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
  </g>


  <g transform="translate(28, 0)">
    <rect width="24" height="24" fill="#00804d" rx="3" />
    <path fill="#ffffff" d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
  </g>


  <g transform="translate(56, 0)">
    <rect width="24" height="24" fill="#00804d" rx="3" />
    <path fill="#ffffff" d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
  </g>


  <g transform="translate(84, 0)">
    <rect width="24" height="24" fill="#00804d" rx="3" />
    <path fill="#ffffff" d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
  </g>

  <g transform="translate(112, 0)">
    <rect width="24" height="24" fill="#00804d" rx="3" />
    <path fill="url(#starFillHalf)" d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
  </g>
</svg>
    </>
  )
};
